/*
 * Filename: afterSave-redirectTo-rule.controller.ts
 * Description: Controller for afterSave-redirectTo layout event rule
 */

import { CQAppConstant } from '../../../app-constants';
import { FormRuleController } from '../form-rule.controller';
import { IAfterSaveRuleObject } from '../IRules.interface';

export class CQAfterSaveRedirectToRuleController extends FormRuleController{
    public ruleJSON = {};

    constructor(ruleObject: IAfterSaveRuleObject) {
        super();
        this.formRuleJson(ruleObject);
    }

    /**
     * @private
     * @memberof CQAfterSaveRedirectToRuleController
     */
    private formRuleJson = (ruleObject: IAfterSaveRuleObject) => {
        const redirectTo = this.formRuleFilter(ruleObject);
        this.ruleJSON = {
            [CQAppConstant.COMPONENT_EVENT_RULES_MAP.afterSaveRedirectTo.key]: {
                afterSave: {
                    redirectTo: {
                        filter: redirectTo.filter || '',
                        query: redirectTo.query || '',
                    },
                },
            },
        };

        return this.formRuleJson;
    };

    /**
     * @memberof CQAfterSaveRedirectToRuleController
     */
    public formRuleFilter = (ruleObject: IAfterSaveRuleObject) => {
        const { redirectTo } = ruleObject;
        redirectTo.filter = redirectTo.shouldSkip
            ? 'true'
            : this.formFilterString(
                redirectTo.complexLogicQuery,
                redirectTo.addedCriterias
            );

        return redirectTo;
    }; 
}
